<template>
  <div>
    <div id="sliders" class="panel active">
      <div class="panel-content px-xs-4 px-md-0 pt-xs-4 pt-md-80">
        <div class="narrow">
        <h1 v-html="$getString('GLOBAL_SIGNS_OF_A_MOTOR_DELAY')"></h1>
          <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>
          <h2 class="mb-xs-2" v-if="ageGroup" v-html="$getTemplatedString('SLIDERS_HOW_OLD_SIGNS', { 'age_state': ageGroup.state })"></h2>
          <p class="smaller fg-sma-black-75" v-html="$getString('SLIDERS_DRAG_THE_SLIDER')"></p>
        </div>

        <div class="slider-wrapper bg-sma-turquoise-10 py-md-4 mb-xs-20">
          <div class="slider-container p-xs-4 pb-xs-40">
            <div
              id="slider-1"
              class="noui-slider"
              data-start="0"
              data-min="0"
              data-max="4"
              data-step="1"
              data-breakpoints=""
              :data-template="$getString('SLIDERS_TEMPLATE_HOW_OLD_SIGNS')"
            ></div>
            <div class="slider-tooltip"></div>
          </div>
        </div>

        <div class="narrow">
          <h2 class="mb-xs-2" v-if="ageGroup" v-html="$getTemplatedString('SLIDERS_HOW_CONCERNED', { 'age_state': ageGroup.state })"></h2>
          <p class="smaller fg-sma-black-75" v-html="$getString('SLIDERS_DRAG_THE_SLIDER')"></p>
        </div>
        <div class="slider-wrapper bg-sma-turquoise-10 py-md-4 mb-xs-20">
          <div class="slider-container p-xs-4 pb-xs-40">
            <div
              id="slider-2"
              class="noui-slider"
              data-start="0"
              data-min="0"
              data-max="4"
              data-step="1"
              data-breakpoints=""
              :data-template="$getString('SLIDERS_TEMPLATE_HOW_CONCERNED')"
            ></div>
            <div class="slider-tooltip"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="questionnaire-buttons container text-centered">
      <div class="tool-button previous mx-xs-2" @click="onPrevious" v-html="$getString('GLOBAL_BUTTON_BACK')"></div>
      <div :class="[ 'tool-button next mx-xs-2', { disabled: !next } ]" @click="onFinish" v-html="$getString('GLOBAL_BUTTON_FINISH')"></div>
    </div>
  </div>
</template>

<script>
const noUiSlider = window.noUiSlider;

export default {
  name: 'StageSliders',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      ageGroup: null,
      sliders: [],
      initialised: false,
      next: false,
    }
  },
  methods: {
    onPrevious() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Back`,
      } });

      this.$emit('action', { type: 'goto-stage', data: 'questions' });
    },
    onFinish() {
      if (!this.next) return;

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Questionnaire_btn_finish`,
      } });
      
      this.$emit('action', { type: 'complete-progress' });
      this.$emit('action', { type: 'goto-stage', data: 'summary' });
    },

    initSliders() {
      this.setupSliders();

      const sliderData = this.$store.getters.dataKey('sliders');
      const sliders = document.querySelectorAll('.noui-slider');

      sliders.forEach(slider => {
        const breakpoints = JSON.parse(slider.getAttribute('data-breakpoints'));
        const max = parseInt(slider.getAttribute('data-max'));
        
        noUiSlider.create(slider, {
          connect: 'lower',
          start: parseInt(slider.getAttribute('data-start')),
          step: parseInt(slider.getAttribute('data-step')),
          range: {
            'min': parseInt(slider.getAttribute('data-min')),
            'max': max
          },
        });

        slider.noUiSlider.on('update', () => this.onSliderUpdate(slider));
        slider.noUiSlider.on('change', () => this.onSliderChange(slider));

        const track = slider.querySelector('.noUi-connects');

        const lower = document.createElement('div');
        const offset = 1 / max * 100;
        lower.classList.add('label', 'label-lower');
        lower.innerHTML = breakpoints[1];
        lower.style = `left:${offset}%`;
        track.append(lower);

        const upper = document.createElement('div');
        upper.classList.add('label', 'label-upper');
        upper.innerHTML = breakpoints[max];
        track.append(upper);

        setTimeout(() => {
          const tooltip = slider.parentElement.querySelector('.slider-tooltip');
          this.initTooltip(tooltip, this.$getString('SLIDERS_TOOLTIP_PROMPT'));
          this.initialised = true;
          if (sliderData[slider.id]) slider.noUiSlider.set(sliderData[slider.id].index);
          this.checkNextButton(sliderData);
        }, 100);

        this.sliders.push(slider);
      });
    },

    setupSliders() {
      for (let i = 0; i < this.ageGroup.sliders.length; i += 1) {
        this.setSliderBreakpoints(i);
      }
    },
    setSliderBreakpoints(index) {
      const config = this.ageGroup.sliders[index];
      const slider = document.getElementById(`slider-${index + 1}`);

      slider.setAttribute('data-breakpoints', JSON.stringify(config.breakpoints));
      slider.setAttribute('data-start', 0);
      slider.setAttribute('data-min', 0);
      slider.setAttribute('data-max', config.breakpoints.length - 1);
      slider.setAttribute('data-step', 1);
      slider.setAttribute('data-label', config.label);
      slider.setAttribute('data-index', index);
    },

    initTooltip(tooltip, value) {
      tooltip.innerHTML = value;
      tooltip.style.left = `0px`;
    },
    setTooltipPosition(slider, tooltip) {
        const sliderWidth = slider.clientWidth;
        const tooltipWidth = tooltip.clientWidth;
        const offset = 15;

        const value = slider.noUiSlider.get(true);
        const max = parseInt(slider.getAttribute('data-max'));
        const valueAsPercentage = value / max * 100;
        const margin = tooltipWidth / 2 - offset;

        let position = sliderWidth / 100 * valueAsPercentage;
        position = Math.min(sliderWidth - (tooltipWidth / 2 + margin), Math.max(offset, position - margin));
        tooltip.style.left = `${position}px`;
    },
    onSliderUpdate(slider) {
      const value = slider.noUiSlider.get(true);
      if (this.initialised && value < 1) {
        slider.noUiSlider.set(1);
      }
      const tooltip = slider.parentElement.querySelector('.slider-tooltip');
      this.setTooltipContent(slider, tooltip);
      this.setTooltipPosition(slider, tooltip);
    },
    onSliderChange(slider) {
      this.storeSliderValues(slider);
      this.storeAnalytics(slider);
    },
    getTooltipValue(slider) {
        const breakpointString = slider.getAttribute('data-breakpoints');
        if (!breakpointString) return;

        const value = slider.noUiSlider.get(true);
        const breakpoints = JSON.parse(breakpointString);

        let counter = 0,
            string = '';
        breakpoints.forEach(item => {
            if (value >= counter) {
                string = item;
            }
            counter += parseInt(slider.getAttribute('data-max')) / breakpoints.length;
        });

        return string;
    },
    setTooltipContent(slider, tooltip) {
        const breakpointLabel = slider.getAttribute('data-label') || '';
        const string = this.getTooltipValue(slider);
        if (string) {
            tooltip.innerHTML = string + breakpointLabel;
        }
    },
    storeSliderValues(slider) {
      const sliderData = this.$store.getters.dataKey('sliders');
      const breakpointLabel = slider.getAttribute('data-label') || '';
      const string = this.getTooltipValue(slider) + breakpointLabel;
      const value = slider.noUiSlider.get(true);
      const template = slider.getAttribute('data-template');

      let data = template.replace('{value}', string.toLowerCase());
      sliderData[slider.id] = {
        index: value,
        string: data.replace('{child_state}', this.ageGroup.state),
      };
      this.$store.commit('SetData', { key: 'sliders', value: sliderData });
      this.checkNextButton(sliderData);
    },
    checkNextButton(sliderData) {
      this.next = Object.keys(sliderData).length === this.sliders.length;
    },
    storeAnalytics(slider) {
      const sliderIndex = parseInt(slider.getAttribute('data-index'));
      const analytics = this.ageGroup.sliders[sliderIndex].analytics;
      const value = this.getTooltipValue(slider).toLowerCase().replace(' ', '_');
      const suffix = analytics.suffix ? `_${analytics.suffix}` : '';

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_${analytics.label}_${value}${suffix}`,
      } });
    },
  },
  mounted() {
    this.ageGroup = this.$store.getters.ageGroup;
    this.initSliders();
  },
}
</script>
